import type { HsGeometry } from '../../graphic-engine-new/geometry/geometry.interface';
import type { HsMaterial } from '../../graphic-render-new/materials/material.class';
import { HsHypersceneConstants } from '../../math-new/constants/hyperscene-constants.global';
import type { HsColor } from '../../math-new/objects/color.class';
import { HsMatrix4 } from '../../math-new/objects/matrix4.class';
import { HsQuaternion } from '../../math-new/objects/quaternion.class';
import type { HsHypersceneTypes } from '../../math-new/types/hyperscene-types.type';
import { HsControlTool } from './control-tool.class';
import type { HsToolAction } from './tool-action.class';
import { getUuid } from '@sibe/utilities/common';

export class HsArrowTool extends HsControlTool {
  constructor(
    geometry: HsGeometry,
    material: HsMaterial,
    action: HsToolAction,
    rotation: HsHypersceneTypes.Array3,
    color: HsColor,
    rotationAngle: number
  ) {
    super(getUuid(), 'arrow_tool', geometry, material, action);
    const rotationMatrix: HsMatrix4 = HsMatrix4.compose(
      HsHypersceneConstants.ZERO_VECTOR3.values,
      HsQuaternion.makeFromAxisAndAngle(rotation, rotationAngle).values,
      [1, 1, 1]
    );
    this.worldMatrix.multiply(rotationMatrix);
    this.updateBoundingSphere();
    this.material.color = color;
  }
}
